import { render, staticRenderFns } from "./NewNotification.vue?vue&type=template&id=dd32020a&"
import script from "./NewNotification.vue?vue&type=script&lang=ts&"
export * from "./NewNotification.vue?vue&type=script&lang=ts&"
import style0 from "./NewNotification.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports